/** @format */

import {
	HmfBadgeComponent,
	HmfButtonComponent,
	HmfProductImageComponent
} from '@dsg-tech/homefield-angular';
import {
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService,
	homefieldIconArrowDown,
	homefieldIconZoomImage
} from '@dsg-tech/homefield-angular-icons';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ProductImageComponent } from '../product-image/product-image.component';
import { ProductImageViewerComponent } from './product-image-viewer.component';
import { StyliticsJumplinkComponent } from '../stylitics-jumplink/stylitics-jumplink.component';

@NgModule({
	declarations: [ProductImageViewerComponent],
	imports: [
		CommonModule,
		HmfBadgeComponent,
		HmfButtonComponent,
		HmfProductImageComponent,
		HomefieldIconLibraryModule,
		ProductImageComponent,
		StyliticsJumplinkComponent
	],
	exports: [ProductImageViewerComponent]
})
export class ProductImageViewerModule {
	constructor(homefieldIconsLibraryService: HomefieldIconsLibraryService) {
		homefieldIconsLibraryService.registerIcons([
			homefieldIconZoomImage,
			homefieldIconArrowDown
		]);
	}
}
